import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmMaximize = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon-llm-maximize",
    "data-icon": "icon-llm-maximize",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("polyline", {
      points: "15 3 21 3 21 9"
    }), jsx("polyline", {
      points: "9 21 3 21 3 15"
    }), jsx("line", {
      x1: "21",
      x2: "14",
      y1: "3",
      y2: "10"
    }), jsx("line", {
      x1: "3",
      x2: "10",
      y1: "21",
      y2: "14"
    })]
  }));
});
IconLlmMaximize.displayName = 'IconLlmMaximize';

export { IconLlmMaximize };
//# sourceMappingURL=llm-maximize.js.map
